import * as React from "react"
import { BackHandIcon } from "../atoms/icons/BackHandIcon"
import { ElectricBoltIcon } from "../atoms/icons/ElectricBoltIcon"
import { HeightIcon } from "../atoms/icons/HeightIcon"
import { MagnificationIcon } from "../atoms/icons/MagnificationIcon"
import { ScaleIcon } from "../atoms/icons/ScaleIcon"
import { WidthIcon } from "../atoms/icons/WidthIcon"
import { FeatherIcon } from "../atoms/icons/FeatherIcon"
import { NetworkIcon } from "../atoms/icons/NetworkIcon"
import { LightbulbIcon } from "../atoms/icons/LightbulbIcon"
import { GlobeIcon } from "../atoms/icons/GlobeIcon"
import { LuggageIcon } from "../atoms/icons/LuggageIcon"
import { DashboardIcon } from "../atoms/icons/DashboardIcon"

interface AttributeIconProps {
  icon: string
}

export const CableEntryPortIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 19V4H15V3H5V19H3V21H15V6H17V21H21V19H19ZM13 19H7V5H13V19ZM10 11H12V13H10V11Z" fill="#616161" />
  </svg>
)
export const BatterySaverIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 4H14V2H10V4H8C7.45 4 7 4.45 7 5V21C7 21.55 7.45 22 8 22H16C16.55 22 17 21.55 17 21V5C17 4.45 16.55 4 16 4ZM15 14H13V16H11V14H9V12H11V10H13V12H15V14Z"
      fill="#616161"
    />
  </svg>
)
export const FlightIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.5 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2.5 14V16L10.5 13.5V19L8.5 20.5V22L12 21L15.5 22V20.5L13.5 19V13.5L21.5 16Z"
      fill="#616161"
    />
  </svg>
)
export const RemovableFloorIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0433 10.1416L2.43248 14.168C1.85584 14.4731 1.85584 15.3432 2.43248 15.6482L11.6497 20.5245C11.8702 20.6412 12.1298 20.6412 12.3503 20.5245L21.5675 15.6482C22.1442 15.3432 22.1442 14.4731 21.5675 14.168L13.957 10.1417V11.9925L19.4681 14.9081L12 18.859L4.53194 14.9081L10.0433 11.9924V10.1416Z"
      fill="#616161"
    />
    <path
      d="M14.8024 8.61483L15.9061 7.44794L11.9924 3.31001L8.07874 7.44794L9.18239 8.61484L11.2097 6.47966L11.2097 14.4824L12.7752 14.4824L12.7752 6.47966L14.8024 8.61483Z"
      fill="#616161"
    />
  </svg>
)
export const CellTowerIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.3 14.25L8.5 13.05C7.5 12.05 7 10.75 7 9.55C7 8.25 7.5 6.95 8.5 6.05L7.3 4.85C6 6.15 5.3 7.85 5.3 9.55C5.3 11.25 6 12.95 7.3 14.25Z"
      fill="#616161"
    />
    <path
      d="M19.1 2.45L17.9 3.65C19.5 5.25 20.3 7.45 20.3 9.55C20.3 11.65 19.5 13.85 17.9 15.45L19.1 16.65C21.1 14.65 22 12.15 22 9.55C22 6.95 21 4.45 19.1 2.45Z"
      fill="#616161"
    />
    <path
      d="M6.1 3.65L4.9 2.45C3 4.45 2 6.95 2 9.55C2 12.15 3 14.65 4.9 16.65L6.1 15.45C4.5 13.85 3.7 11.65 3.7 9.55C3.7 7.45 4.5 5.25 6.1 3.65Z"
      fill="#616161"
    />
    <path
      d="M16.7 14.25C18 12.95 18.7 11.25 18.7 9.55C18.6 7.85 18 6.15 16.7 4.85L15.5 6.05C16.5 7.05 17 8.35 17 9.55C17 10.85 16.5 12.15 15.5 13.05L16.7 14.25Z"
      fill="#616161"
    />
    <path
      d="M14.5 9.55C14.5 8.17 13.38 7.05 12 7.05C10.62 7.05 9.5 8.17 9.5 9.55C9.5 10.31 9.84 10.97 10.37 11.43L7 21.55H9L9.67 19.55H14.34L15 21.55H17L13.63 11.43C14.16 10.97 14.5 10.31 14.5 9.55ZM10.33 17.55L12 12.55L13.67 17.55H10.33Z"
      fill="#616161"
    />
  </svg>
)
export const WaterDropIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.67 6.55 4 10.48 4 13.8C4 18.78 7.8 22 12 22C16.2 22 20 18.78 20 13.8C20 10.48 17.33 6.55 12 2ZM12 20C8.65 20 6 17.43 6 13.8C6 11.46 7.95 8.36 12 4.66C16.05 8.36 18 11.45 18 13.8C18 17.43 15.35 20 12 20ZM7.83 14C8.2 14 8.5 14.26 8.57 14.62C8.98 16.84 10.85 17.6 12.21 17.49C12.64 17.47 13 17.81 13 18.24C13 18.64 12.68 18.97 12.28 18.99C10.15 19.12 7.66 17.9 7.09 14.87C7.01 14.42 7.37 14 7.83 14Z"
      fill="#616161"
    />
  </svg>
)
export const RulerIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.89474 18C3.36842 18 2.92105 17.8091 2.55263 17.4273C2.18421 17.0455 2 16.5818 2 16.0364V7.96364C2 7.41818 2.18421 6.95455 2.55263 6.57273C2.92105 6.19091 3.36842 6 3.89474 6H20.1053C20.6316 6 21.0789 6.19091 21.4474 6.57273C21.8158 6.95455 22 7.41818 22 7.96364V16.0364C22 16.5818 21.8158 17.0455 21.4474 17.4273C21.0789 17.8091 20.6316 18 20.1053 18H3.89474ZM3.89474 16.3636H20.1053C20.1754 16.3636 20.2456 16.3273 20.3158 16.2545C20.386 16.1818 20.4211 16.1091 20.4211 16.0364V7.96364C20.4211 7.89091 20.386 7.81818 20.3158 7.74546C20.2456 7.67273 20.1754 7.63636 20.1053 7.63636H17V11.5909H15.4211V7.63636H12.7895V11.5909H11.2105V7.63636H8.57895V11.5909H7V7.63636H3.89474C3.82456 7.63636 3.75439 7.67273 3.68421 7.74546C3.61404 7.81818 3.57895 7.89091 3.57895 7.96364V16.0364C3.57895 16.1091 3.61404 16.1818 3.68421 16.2545C3.75439 16.3273 3.82456 16.3636 3.89474 16.3636Z"
      fill="#616161"
    />
  </svg>
)
export const ElectricalServiceIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 14.25C22 13.6313 21.5 13.125 20.8889 13.125H18.6667V15.375H20.8889C21.5 15.375 22 14.8687 22 14.25Z"
      fill="#616161"
    />
    <path
      d="M20.8889 17.625H18.6667V19.875H20.8889C21.5 19.875 22 19.3687 22 18.75C22 18.1313 21.5 17.625 20.8889 17.625Z"
      fill="#616161"
    />
    <path
      d="M12 14.25H9.77778V18.75H12C12 19.9875 13 21 14.2222 21H17.5556V12H14.2222C13 12 12 13.0125 12 14.25Z"
      fill="#616161"
    />
    <path
      d="M4.22222 13.125C4.22222 11.8875 5.22222 10.875 6.44444 10.875H8.11111C10.2556 10.875 12 9.10875 12 6.9375C12 4.76625 10.2556 3 8.11111 3H4.22222C3.61111 3 3.11111 3.50625 3.11111 4.125C3.11111 4.74375 3.61111 5.25 4.22222 5.25H8.11111C9.03333 5.25 9.77778 6.00375 9.77778 6.9375C9.77778 7.87125 9.03333 8.625 8.11111 8.625H6.44444C3.98889 8.625 2 10.6388 2 13.125C2 15.6112 3.98889 17.625 6.44444 17.625H8.66667V15.375H6.44444C5.22222 15.375 4.22222 14.3625 4.22222 13.125Z"
      fill="#616161"
    />
  </svg>
)
export const VpnLockIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.2909 12C18.3273 12.3 18.3636 12.6 18.3636 12.9091C18.3636 14.8 17.6364 16.5182 16.4545 17.8091C16.2182 17.0727 15.5455 16.5455 14.7273 16.5455H13.8182V13.8182C13.8182 13.3182 13.4091 12.9091 12.9091 12.9091H7.45455V11.0909H9.27273C9.77273 11.0909 10.1818 10.6818 10.1818 10.1818V8.36364H12C13 8.36364 13.8182 7.54545 13.8182 6.54545V4.23636C12.9545 3.96364 12.0455 3.81818 11.0909 3.81818C6.07273 3.81818 2 7.89091 2 12.9091C2 17.9273 6.07273 22 11.0909 22C16.1091 22 20.1818 17.9273 20.1818 12.9091C20.1818 12.6 20.1636 12.3 20.1364 12H18.2909ZM10.1818 20.1182C6.59091 19.6727 3.81818 16.6182 3.81818 12.9091C3.81818 12.3455 3.89091 11.8091 4.00909 11.2818L8.36364 15.6364V16.5455C8.36364 17.5455 9.18182 18.3636 10.1818 18.3636V20.1182ZM21.0909 4.72727V4.27273C21.0909 3.01818 20.0727 2 18.8182 2C17.5636 2 16.5455 3.01818 16.5455 4.27273V4.72727C16.0455 4.72727 15.6364 5.13636 15.6364 5.63636V9.27273C15.6364 9.77273 16.0455 10.1818 16.5455 10.1818H21.0909C21.5909 10.1818 22 9.77273 22 9.27273V5.63636C22 5.13636 21.5909 4.72727 21.0909 4.72727ZM20.1818 4.72727H17.4545V4.27273C17.4545 3.51818 18.0636 2.90909 18.8182 2.90909C19.5727 2.90909 20.1818 3.51818 20.1818 4.27273V4.72727Z"
      fill="#616161"
    />
  </svg>
)
export const ShieldIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C9.68333 21.4167 7.771 20.0873 6.263 18.012C4.75433 15.9373 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.246 15.9373 17.738 18.012C16.2293 20.0873 14.3167 21.4167 12 22ZM12 19.9C13.7333 19.35 15.1667 18.25 16.3 16.6C17.4333 14.95 18 13.1167 18 11.1V6.375L12 4.125L6 6.375V11.1C6 13.1167 6.56667 14.95 7.7 16.6C8.83333 18.25 10.2667 19.35 12 19.9Z"
      fill="#616161"
    />
    <path d="M16.2625 13.5146V7.51463L12.2625 6.01463" stroke="#616161" strokeWidth="1.5" />
  </svg>
)

export const RotateIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 13.4286C2 18.1619 5.8381 22 10.5714 22C12.2476 22 13.8095 21.5143 15.1333 20.6857L13.7429 19.2952C12.8 19.8 11.7143 20.0952 10.5714 20.0952C6.89524 20.0952 3.90476 17.1048 3.90476 13.4286C3.90476 9.75238 6.89524 6.7619 10.5714 6.7619H10.7333L9.22857 8.27619L10.5714 9.61905L14.381 5.80952L10.5714 2L9.21905 3.34286L10.7333 4.85714H10.5714C5.8381 4.85714 2 8.69524 2 13.4286ZM10.5714 13.4286L16.2857 19.1429L22 13.4286L16.2857 7.71429L10.5714 13.4286ZM16.2857 16.4476L13.2667 13.4286L16.2857 10.4095L19.3048 13.4286L16.2857 16.4476Z"
      fill="#616161"
    />
  </svg>
)
export const UvResistantIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_619_713)">
      <path
        d="M19.9999 8.69V4H15.3099L11.9999 0.690001L8.68994 4H3.99994V8.69L0.689941 12L3.99994 15.31V20H8.68994L11.9999 23.31L15.3099 20H19.9999V15.31L23.3099 12L19.9999 8.69ZM17.9999 14.48V18H14.4799L11.9999 20.48L9.51994 18H5.99994V14.48L3.51994 12L5.99994 9.52V6H9.51994L11.9999 3.52L14.4799 6H17.9999V9.52L20.4799 12L17.9999 14.48ZM11.9999 6.5C8.96994 6.5 6.49994 8.97 6.49994 12C6.49994 15.03 8.96994 17.5 11.9999 17.5C15.0299 17.5 17.4999 15.03 17.4999 12C17.4999 8.97 15.0299 6.5 11.9999 6.5ZM11.9999 15.5C10.0699 15.5 8.49994 13.93 8.49994 12C8.49994 10.07 10.0699 8.5 11.9999 8.5C13.9299 8.5 15.4999 10.07 15.4999 12C15.4999 13.93 13.9299 15.5 11.9999 15.5Z"
        fill="#616161"
      />
    </g>
    <defs>
      <clipPath id="clip0_619_713">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const AttributeIcon: React.FunctionComponent<AttributeIconProps> = ({ icon, ...props }) => {
  switch (icon) {
    case "width":
      return <WidthIcon />
    case "height":
      return <HeightIcon />
    case "backhand":
      return <BackHandIcon />
    case "weight":
      return <ScaleIcon />
    case "electricity":
      return <ElectricBoltIcon />
    case "plane":
      return <FlightIcon />
    case "size":
      return <MagnificationIcon />
    case "dimension":
      return <RulerIcon />
    case "feather":
      return <FeatherIcon />
    case "network":
      return <NetworkIcon />
    case "lightbulb":
      return <LightbulbIcon />
    case "globe":
      return <GlobeIcon />
    case "cable":
      return <CableEntryPortIcon />
    case "batterysaver":
      return <BatterySaverIcon />
    case "flight":
      return <FlightIcon />
    case "removeablefloor":
      return <RemovableFloorIcon />
    case "celltower":
      return <CellTowerIcon />
    case "waterdrop":
      return <WaterDropIcon />
    case "ruler":
      return <RulerIcon />
    case "electricalservice":
      return <ElectricalServiceIcon />
    case "vpnlock":
      return <VpnLockIcon />
    case "shield":
      return <ShieldIcon />
    case "leaf":
      return <FeatherIcon />
    case "rotate":
      return <RotateIcon />
    case "uvresistant":
      return <UvResistantIcon />
    case "luggage":
      return <LuggageIcon />
    case "dashboard":
      return <DashboardIcon />
    default:
      return <div />
  }
}

export default AttributeIcon
